import { api } from "./client";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = window.atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
export const isStandalone = () => window.matchMedia("(display-mode: standalone)").matches || navigator.standalone === true;
export const needsPushInstall = () => isIOS() && !isStandalone();
export const autoPushBlocked = () => /android/i.test(navigator.userAgent) && pushPermission() === "default" && Number(localStorage.getItem("poehali_push_prompt_dismissals") || 0) >= 2;

export const pushSupported = () =>
  "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;

export const pushPermission = () =>
  typeof Notification === "undefined" ? "unsupported" : Notification.permission;

export async function pushStatus() {
  const { data } = await api.get("/push/status");
  return data;
}

export async function currentSubscription() {
  if (!pushSupported()) return null;
  const reg = await navigator.serviceWorker.ready;
  return reg.pushManager.getSubscription();
}

export async function enablePush() {
  if (needsPushInstall()) throw new Error("install_required");
  if (!pushSupported()) throw new Error("unsupported");
  let permission = pushPermission();
  if (permission === "default") {
    const key = "poehali_push_prompt_attempts";
    localStorage.setItem(key, String(Number(localStorage.getItem(key) || 0) + 1));
    permission = await Notification.requestPermission();
    if (permission === "default") {
      const dismissed = "poehali_push_prompt_dismissals";
      localStorage.setItem(dismissed, String(Number(localStorage.getItem(dismissed) || 0) + 1));
      window.dispatchEvent(new Event("push-state-changed"));
      throw new Error("dismissed");
    }
  }
  if (permission !== "granted") throw new Error("denied");
  const { data } = await api.get("/push/vapid-public-key");
  if (!data.key) throw new Error("no_key");
  const reg = await navigator.serviceWorker.ready;
  const sub =
    (await reg.pushManager.getSubscription()) ||
    (await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(data.key),
    }));
  const json = sub.toJSON();
  await api.post("/push/subscribe", { endpoint: json.endpoint, keys: json.keys });
  return true;
}

export async function disablePush() {
  const sub = await currentSubscription();
  if (!sub) return true;
  const { endpoint } = sub.toJSON();
  await sub.unsubscribe().catch(() => null);
  await api.post("/push/unsubscribe", { endpoint }).catch(() => null);
  return true;
}
